import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getProjectByIdApi, updateProjectDataByIdApi } from '@src/api';
import { ProjectUpdateData } from '@src/views/project/types';

const getProjectGuide = createAsyncThunk(
  'get/projectGuide',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getProjectByIdApi(id);
      return response.result.data;
    } catch (err) {
      throw rejectWithValue(err);
    }
  }
);

const updateProjectGuide = createAsyncThunk(
  'update/projectGuide',
  async (
    { id, data }: { id: number; data: ProjectUpdateData },
    { rejectWithValue }
  ) => {
    try {
      const response = await updateProjectDataByIdApi(id, data);
      return response.result;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        throw rejectWithValue(err.response?.data);
      }
    }
  }
);

export { getProjectGuide, updateProjectGuide };
